const styles = ({ overrides }) => ({
  button: {
    fontSize: 18,
    lineHeight: "22px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    color: "var(--theme-black)",
    border: 0,
    appearance: "none",
    cursor: "pointer",

    "&[disabled]": {
      opacity: 0.5,
      cursor: "not-allowed",
    },

    "& .icon": {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 35,
      height: 35,
      padding: 9,
      border: "1px solid",
      transform: "rotate(-90deg)",
      transition: "all .3s ease-in-out",
      margin: 0,
      borderRadius: "50%",
      "& svg": {
        width: "100%",
        "& path": {
          fill: "var(--theme-white)",
        },
      },
    },
    "& .text": {
      position: "relative",
      zIndex: 1,
    },
    "&.primary": {
      backgroundColor: "var(--theme-" + overrides.colour + ")",
      color: "var(--theme-white)",
      fontWeight: "bold",
      letterSpacing: "0.008em",
      borderRadius: 8,
      textTransform: "uppercase",
      boxShadow: "0px 8px 24px rgba(183, 182, 182, 0.56)",
      transition: "border-radius .3s ease-in-out",
      padding: "15px 35px 15px 25px",
      "& .icon": {
        borderColor: "var(--theme-" + overrides.colour + ")",
        marginRight: 2,
        padding: 7,
      },
      "&:not([disabled]):hover, &:not([disabled]):focus": {
        borderRadius: 40,
        "& .icon": {
          width: 73,
          height: 73,
          margin: -19,
          marginLeft: -30,
          marginRight: -6,
          padding: 26,
        },
      },
      "&.white": {
        color: "var(--theme-black)",
        "& .icon": {
          "& path": {
            fill: "var(--theme-black)",
          },
        },
      },
    },
    "&.secondary": {
      letterSpacing: "0.016em",
      transition: "padding-left .3s ease-in-out",
      "& .icon": {
        borderColor: "var(--theme-" + overrides.colour + ")",
        marginRight: 16,
        "& path": {
          fill: "var(--theme-" + overrides.colour + ")",
        },
      },
      "&:hover, &:focus": {
        paddingLeft: 10,
        "& .icon": {
          backgroundColor: "var(--theme-" + overrides.colour + ")",
          "& path": {
            fill: "var(--theme-white)",
          },
        },
      },
      "&.white": {
        "&:hover, &:focus": {
          "& .icon": {
            "& path": {
              fill: "var(--theme-black)",
            },
          },
        },
      },
    },
    "&.tertiary": {
      letterSpacing: "0.016em",
      fontSize: 16,
      transition: "color .3s ease-in-out, padding-left .3s ease-in-out",
      "&:hover, &:focus": {
        fontWeight: "bold",
        paddingLeft: "var(--gutter)",
        color: "var(--theme-" + overrides.colour + ")",
      },
      "& .text": {
        textDecoration: "underline",
      },
      "&.white": {
        "&:hover, &:focus": {
          color: "var(--theme-white)",
        },
      },
    },
  },
})

export default styles
